module.exports = __webpack_public_path__ + "img/IC_Msg_Sucess.3981ccbb.svg";